import React, { useEffect, useRef, useState } from "react";
import ExecutiveContactDetails from "../../../common/form/executiveContactDetails";
import ActionSection from "features/terminal-details/common/actionSection";
import { TerminalState } from "../../../../slices/terminal-summary/TerminalDetailsState";
import { terminalDetailsSelector } from "../../../../slices/terminal-summary/terminalDetailsSlice";
import { useSelector } from "react-redux";
import { Form, Formik, FormikProps } from "formik";
import { getContactValidation } from "../../../../app/data/terminal-details/models";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { getTerminalSummaryByTerminalNumber } from "../../../../slices/terminal-summary/terminalDetailsSlice";
import { Divider } from "features/terminal-details/common/divider";
import Contact from "features/common/form/contact";
import { Contact as ContactModel } from 'app/data/terminal-details/models';
import { updateContactSelector, updateTerminalContactById } from "slices/terminal-summary/contactSlice";
import { UpdateContactState } from "slices/terminal-summary/ContactState";
import { toast } from "react-toastify";
import AgentAddressDetails from "features/common/form/agentAddressDetails";

export default function EditContact({ onClose }: { onClose: () => void }): React.ReactElement {
    const [spinner, setSpinner] = useState<boolean>(false);
    const terminalState: TerminalState = useSelector(terminalDetailsSelector);
    const updateContactState: UpdateContactState = useSelector(updateContactSelector);
    const dispatch = useDispatch();
    const formRef = useRef<FormikProps<ContactModel>>(null);

    const handleSpinner = () => {
        setTimeout(() => {
            setSpinner(false);
        }, 1000);
    };

    useEffect(() => {
        if (updateContactState.isSuccess) {
            dispatch(getTerminalSummaryByTerminalNumber(terminalState.data?.terminalNumber?.toString() || ""));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateContactState, dispatch]);

    const handleClear = () => {
        formRef.current?.resetForm();
    };
    const initialValues: ContactModel = {
        phoneNumber: terminalState.data?.contact?.phoneNumber?.formatPhone() || '',
        terminalEmail: terminalState.data?.contact?.terminalEmail || '',
        managerName: terminalState.data?.contact?.managerName || '',
        managerEmail: terminalState.data?.contact?.managerEmail || '',
        managerPhone: terminalState.data?.contact?.managerPhone?.formatPhone() || '',
        agentName: terminalState.data?.contact?.agentName || '',
        agentEmail: terminalState.data?.contact?.agentEmail || '',
        agentPhone: terminalState.data?.contact?.agentPhone?.formatPhone() || '',
        agentAddress: terminalState.data?.contact?.agentAddress || '',
        agCity: terminalState.data?.contact?.agCity || '',
        agState: terminalState.data?.contact?.agState || '',
    };

    return (
        <>
            {terminalState?.data?.contact && <>
                <Formik
                    onSubmit={() => { }}
                    innerRef={formRef}
                    enableReinitialize
                    validationSchema={getContactValidation()}
                    initialValues={initialValues} >
                    {(formikProps: FormikProps<ContactModel>) => (
                        <Form>
                            <Contact />
                            <div className="margin-bottom-28" />
                            <div className="form-heading">Manager Details</div>
                            <Divider className="margin-20" />
                            <ExecutiveContactDetails executive="manager" label="Manager" required={true} />
                            <div className="margin-bottom-28" />
                            {terminalState.data?.terminalType?.type === "Agent Terminal" && (
                                <>
                                    <div className="form-heading">Agent Details</div>
                                    <Divider className="margin-20" />
                                    <ExecutiveContactDetails executive="agent" label="Agent" required={false} />
                                    <div className="margin-bottom-28" />
                                    <AgentAddressDetails />
                                </>
                            )}

                            <div className="action-section">
                                <ActionSection
                                    handleClear={handleClear}
                                    handleSave={async () => {
                                        setSpinner(true);
                                        const values = formRef.current?.values;

                                        await Promise.all([
                                            formRef?.current?.submitForm()
                                        ]);
                                        handleSpinner();

                                        if (terminalState.data?.contact?.id &&
                                            terminalState.data?.terminalNumber &&
                                            _.isEmpty(formRef.current?.errors)) {
                                            dispatch(updateTerminalContactById(terminalState.data?.terminalNumber?.toString() || "", terminalState.data?.contact?.id || "", {
                                                phoneNumber: values?.phoneNumber || '',
                                                terminalEmail: values?.terminalEmail || '',
                                                managerName: values?.managerName || '',
                                                managerPhone: values?.managerPhone || '',
                                                managerEmail: values?.managerEmail || '',
                                                agentName: values?.agentName || null,
                                                agentPhone: values?.agentPhone || null,
                                                agentEmail: values?.agentEmail || null,
                                                agentAddress: values?.agentAddress || null,
                                                agCity: values?.agCity || null,
                                                agState: values?.agState || null,
                                            }, () => {
                                                toast.info("Updated details");
                                            }, (message: string | object) => {
                                                toast.error(message);
                                            }));
                                        }
                                    }}
                                    spinner={updateContactState.isLoading || spinner}
                                    disabled={!formikProps.dirty}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>

            </>}
        </>
    );
}
